"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.breakpoints = exports.zIndex = exports.opacity = exports.lineHeights = exports.letterSpacing = exports.fontSizes = exports.fontFamilies = exports.fontWeights = exports.boxShadow = exports.borderWidth = exports.borderRadius = exports.colors = exports.spacing = exports.sizing = void 0;
var sizing = {
  small: '24px',
  medium: '36px',
  large: '48px'
};
exports.sizing = sizing;
var spacing = {
  xsmall: '4px',
  small: '8px',
  medium: '16px',
  large: '24px',
  xlarge: '32px'
};
exports.spacing = spacing;
var colors = {
  navyLight: '#213147',
  navy: '#05192D',
  navyDark: '#000820',
  navySubtleTextOnDark: '#9BA3AB',
  navySubtleTextOnLight: '#65707C',
  greenLight: '#65FF8F',
  green: '#03EF62',
  greenDark: '#00C53B',
  greenDarkText: '#008700',
  white: '#FFFFFF',
  greySubtle: '#F7F7FC',
  greyLight: '#efeff5',
  grey: '#e8e8ee',
  greyMedium: '#e1e1e8',
  greyDark: '#848C92',
  beigeSubtle: '#FFFBF3',
  beigeLight: '#F7F3EB',
  beige: '#EFEBE4',
  beigeMedium: '#E5E1DA',
  redLight: '#FF782D',
  red: '#FF5400',
  redDark: '#DD3400',
  redDarkText: '#C01100',
  orangeLight: '#FFBC4B',
  orange: '#FF931E',
  orangeDark: '#D87300',
  orangeDarkText: '#B75900',
  yellowLight: '#FFEC3C',
  yellow: '#FCCE0D',
  yellowDark: '#CFA600',
  yellowDarkText: '#907000',
  blueLight: '#60E7FF',
  blue: '#06BDFC',
  blueDark: '#009BD8',
  blueDarkText: '#0075AD',
  purpleLight: '#974DFF',
  purple: '#7933FF',
  purpleDark: '#5646A5',
  purpleDarkText: '#5646A5',
  pinkLight: '#FF95CF',
  pink: '#FF6EA9',
  pinkDark: '#DC4D8B',
  pinkDarkText: '#BF3072',
  brandFacebook: '#1778F2',
  brandTwitter: '#00ACEE',
  brandGoogle: '#DB4437',
  brandLinkedIn: '#0E76A8'
};
exports.colors = colors;
var borderRadius = {
  medium: '4px',
  circle: '50%'
};
exports.borderRadius = borderRadius;
var borderWidth = {
  thin: '1px',
  medium: '2px',
  thick: '3px',
  xthick: '4px'
};
exports.borderWidth = borderWidth;
var boxShadow = {
  thin: '0px 0px 2px 0px rgba(5, 25, 45, 0.3)',
  medium: '0px 1px 4px -1px rgba(5, 25, 45, 0.3)',
  thick: '0px 3px 5px -1px rgba(5, 25, 45, 0.3)',
  xthick: '0px 8px 12px -4px rgba(5, 25, 45, 0.3)'
};
exports.boxShadow = boxShadow;
var fontWeights = {
  regular: 400,
  bold: 800
};
exports.fontWeights = fontWeights;
var fontFamilies = {
  sansSerif: 'Studio-Feixen-Sans, Arial, sans-serif',
  mono: "JetBrainsMonoNL, Menlo, Monaco, 'Courier New', monospace"
};
exports.fontFamilies = fontFamilies;
var fontSizes = {
  small: '12px',
  medium: '14px',
  large: '16px',
  xlarge: '18px',
  xxlarge: '20px',
  huge: '28px'
};
exports.fontSizes = fontSizes;
var letterSpacing = {
  tight: '-0.5px',
  default: '0px',
  relaxed: '1.5px'
};
exports.letterSpacing = letterSpacing;
var lineHeights = {
  tight: 1,
  default: 1.25,
  relaxed: 1.5
};
exports.lineHeights = lineHeights;
var opacity = {
  low: 0.15,
  medium: 0.4,
  high: 0.6
};
exports.opacity = opacity;
var zIndex = {
  default: 1,
  sticky: 100,
  dropdown: 7000,
  overlay: 8000,
  modal: 9000,
  toast: 10000
};
exports.zIndex = zIndex;
var breakpoints = {
  small: '480px',
  medium: '820px',
  large: '1480px'
};
exports.breakpoints = breakpoints;
var _default = {
  sizing: sizing,
  spacing: spacing,
  colors: colors,
  borderRadius: borderRadius,
  borderWidth: borderWidth,
  boxShadow: boxShadow,
  fontWeights: fontWeights,
  fontFamilies: fontFamilies,
  fontSizes: fontSizes,
  letterSpacing: letterSpacing,
  lineHeights: lineHeights,
  opacity: opacity,
  zIndex: zIndex,
  breakpoints: breakpoints
};
exports.default = _default;
